export default function MultiLineText({ text }: { text: string | null | undefined }) {
    if (!text) {
        return null;
    }
    return (
        <>
            {text.split('\n').map((t, idx) => (
                <p key={idx}>{t}</p>
            ))}
        </>
    );
}
